module.exports = __webpack_public_path__ + "static/media/cancelPolicy.02af7718.svg";